/**
 * Created by rhinov15 on 17/03/2016.
 */

import { EntityNode } from "./EntityNode";
import { CocosConstants } from "../../../../constants";
import { Comment } from "@rhinov/savane-js";

declare var cc: any;

export class CommentNode extends EntityNode {
    constructor(comment: Comment) {
        // Init super class
        super(comment);
        // Create the sprite to display the light symbol
        this._sprite = new cc.Sprite();

        // Set sprite scale and texture and add its physical representation to the display
        this._sprite.setScale(0.25);
        this._sprite.setTexture(this.textureName);
        this.addChild(this._sprite, -1);
    }

    // Return the sprite width
    getWidth (): number {
        return this._sprite.width;
    }

    // Return the sprite height
    getHeight (): number {
        return this._sprite.height;
    }

    // Update the current node, prepare it for display
    update (dt: number) {
        // Call super class
        super.update(dt);

        // Select the correct texture to display depending on the light type and status (selected, hovered or normal)
        if (this._isSelected) {
            this._sprite.setTexture(CocosConstants.resourcesBasePath + '/resources/commentSelected.png');
        }
        else {
            if (this._isHovered) {
                this._sprite.setTexture(CocosConstants.resourcesBasePath + '/resources/commentHovered.png');
            }
            else {
                this._sprite.setTexture(CocosConstants.resourcesBasePath + '/resources/comment.png');
            }
        }
    }

    toRotate (): boolean {
        return false;
    }

    toResize (): boolean {
        return false;
    }
}
